// extracted by mini-css-extract-plugin
module.exports = {"root":"menu-item-leading_root__SmY3m"};